import { useState, Fragment, useContext, useEffect, useRef } from 'react';
import AuthContext from '../../context/authContext';
import clsx from 'clsx';
//import clsx from 'clsx';

// Import Material 
import { Box, Button, CircularProgress, FormControl, InputLabel, makeStyles, MenuItem, Select, Typography } from '@material-ui/core'
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


//Import Components
import { theme } from '../../theme';
import SnackBarSuccess from '../basicComponents/SnackBarSuccess';
import SnackBarError from '../basicComponents/SnackBarError';
import { CreateFeedback } from '../../graphqlCommunication/FeedbackInterface';
import { Rating } from '@material-ui/lab';


const useStyles = makeStyles((theme) => ({
    input: {
        minWidth: 220,
        maxWidth: 340,
    },
    margin: {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    buttonProgress: {
        color: 'green',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 180,
    },
}));

export const DetailFeedbackDialog = ({ handleFeedbackDialogClose, feedbackDialogOpen, feedback }) => {
    const classes = useStyles();


    /*   const values = ({
          name: feedback.name,
          description: feedback.description,
             activeGroup: feedback.activeGroup,
               date: feedback.date,
               toNavigation: feedback.toNavigation,
               toAddNew: feedback.toAddNew,
               toLinkAnalysis: feedback.toLinkAnalysis,
               toImport: feedback.toImport,
               toAdministration: feedback.toAdministration,
               feedbackType: feedback.feedbackType,
               rating: feedback.rating, 
      });
   */
    console.log("feedback");
    console.log(feedback);

    if (feedback === null) {
        return null;
    }

    const values = ({
        name: feedback.name,
        description: feedback.descriptionJson.general,
        toNavigation: feedback.descriptionJson.toNavigation,
        toAddNew: feedback.descriptionJson.toAddNew,
        toLinkAnalysis: feedback.descriptionJson.toLinkAnalysis,
        toImport: feedback.descriptionJson.toImport,
        toAdministration: feedback.descriptionJson.toAdministration,
        feedbackType: feedback.descriptionJson.feedbackType,
        rating: feedback.descriptionJson.rating,
        creator: feedback.creator,
        date: feedback.date,
    });





    const handleClose = () => {
        handleFeedbackDialogClose();
    };



    return (
        <Fragment>
            <Dialog open={feedbackDialogOpen} onClose={handleFeedbackDialogClose} aria-labelledby="form-dialog-title" maxWidth="md" fullWidth="true">
                <DialogTitle id="form-dialog-title">Send Feedback form {values.creator.email}</DialogTitle>



                <DialogContent>


                    <FormControl variant="outlined" className={classes.formControl}>
                        <Typography component="legend">My current satisfaction</Typography>
                        <Rating
                            id="rating"
                            label="Topic"
                            name="rating"
                            value={values.rating}
                        />
                    </FormControl>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="demo-simple-select-outlined-label">Feedback Type</InputLabel>
                        <Select
                            labelId="demo-simple-select-outlined-label"
                            id="feedbackType"
                            name="feedbackType"
                            value={values.feedbackType}
                            label="Feedback Type"
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            <MenuItem value="Bug">Bug</MenuItem>
                            <MenuItem value="Feature">Feature</MenuItem>
                            <MenuItem value="Something else">Something else</MenuItem>
                        </Select>
                    </FormControl>

                    <TextField
                        className={classes.margin}
                        id="name"
                        label="Topic"
                        fullWidth
                        defaultValue={values.name}
                        name="name"
                        variant="outlined"
                        value={values.name}
                        placeholder="Füge hier eine kurze ausagekräftige Überschrift ein, worum es in deinem Feedback geht..."
                    />

                    <TextField
                        margin="dense"
                        id="description"
                        label="General Feedback"
                        fullWidth
                        defaultValue={values.description}
                        multiline
                        rows={5}
                        name="description"
                        variant="outlined"
                        placeholder="Füge hier ein belibiges Feedback ein, was dir auf dem Herzen liegt..."
                        value={values.description}
                    />

                    <Typography className={classes.margin} component="legend">Feedback to the specific areas:</Typography>
                    <TextField
                        margin="dense"
                        id="toNavigation"
                        label="Navigation"
                        fullWidth
                        defaultValue={values.toNavigation}
                        multiline
                        rows={5}
                        name="toNavigation"
                        variant="outlined"
                        placeholder="Ergänze hier dein Feedback zu der Seite Navigation und beziehe dich z.B. auf die Termliste... dem Graphen ... der Deteilansicht der Terme... oder irgend etwas anderem... "
                        value={values.toNavigation}
                    />

                    <TextField
                        margin="dense"
                        id="toAddNew"
                        label="Add New"
                        fullWidth
                        defaultValue={values.toAddNew}
                        multiline
                        rows={5}
                        name="toAddNew"
                        variant="outlined"
                        placeholder="Ergänze hier dein Feedback zu der Seite Add New..."
                        value={values.toAddNew}
                    />

                    <TextField
                        margin="dense"
                        id="toLinkAnalysis"
                        label="Link Analysis"
                        fullWidth
                        defaultValue={values.toLinkAnalysis}
                        multiline
                        rows={5}
                        name="toLinkAnalysis"
                        variant="outlined"
                        placeholder="Ergänze hier dein Feedback zu der Seite Link Analysis..."
                        value={values.toLinkAnalysis}
                    />

                    <TextField
                        margin="dense"
                        id="toImport"
                        label="Import"
                        fullWidth
                        defaultValue={values.toImport}
                        multiline
                        rows={5}
                        name="toImport"
                        variant="outlined"
                        placeholder="Ergänze hier dein Feedback zu der Seite Import..."
                        value={values.toImport}
                    />

                    <TextField
                        margin="dense"
                        id="toAdministration"
                        label="Administration"
                        fullWidth
                        defaultValue={values.toAdministration}
                        multiline
                        rows={5}
                        name="toAdministration"
                        variant="outlined"
                        placeholder="Ergänze hier dein Feedback zu der Seite Administration..."
                        value={values.toAdministration}

                    />


                    <DialogContentText>
                        {"Date: " + values.date}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>


        </Fragment>
    );
}